import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
import useIsBrowser from 'hooks/useIsBrowser';
const QuickshipZipCodeWrapper = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="!text-base !leading-[20px] flex-1">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
QuickshipZipCodeWrapper.propTypes = {
  children: PropTypes.node
};
const QuickshipZipCodeEditLocationUI = t0 => {
  const $ = _c(6);
  const {
    isLoading: t1,
    isUserInUS: t2,
    isZipCodeFromUserServiceable: t3,
    toggleUpdateZipCodeSidebar,
    zipCode,
    zipCodeFromUser
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isUserInUS = t2 === undefined ? true : t2;
  const isZipCodeFromUserServiceable = t3 === undefined ? true : t3;
  const isBrowser = useIsBrowser();
  if (isLoading || !isBrowser) {
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <QuickshipZipCodeWrapper><ProgressLoaderDots inline={true} grey={true} /></QuickshipZipCodeWrapper>;
      $[0] = t4;
    } else {
      t4 = $[0];
    }
    return t4;
  }
  if (!!zipCodeFromUser && !isZipCodeFromUserServiceable || !isUserInUS || !zipCode) {
    let t4;
    if ($[1] !== toggleUpdateZipCodeSidebar) {
      t4 = <QuickshipZipCodeWrapper><button className="items-center flex focus-visible:outline-offset-4 focus:outline-0 text-brand font-bold underline hover:underline" onClick={toggleUpdateZipCodeSidebar} type="button" aria-label="Add your location" data-xc="ProductListingAddLocationButton">Add zip</button></QuickshipZipCodeWrapper>;
      $[1] = toggleUpdateZipCodeSidebar;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  let t4;
  if ($[3] !== toggleUpdateZipCodeSidebar || $[4] !== zipCode) {
    t4 = <QuickshipZipCodeWrapper>to{" "}<button className="items-center focus-visible:outline-offset-4 focus:outline-0 text-brand font-bold underline hover:underline" onClick={toggleUpdateZipCodeSidebar} type="button" aria-label="Update your location" data-xc="ProductListingUpdateLocationButton">{zipCode}</button></QuickshipZipCodeWrapper>;
    $[3] = toggleUpdateZipCodeSidebar;
    $[4] = zipCode;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
QuickshipZipCodeEditLocationUI.propTypes = {
  isLoading: PropTypes.bool,
  isUserInUS: PropTypes.bool,
  isZipCodeFromUserServiceable: PropTypes.bool,
  toggleUpdateZipCodeSidebar: PropTypes.func,
  zipCode: PropTypes.string,
  zipCodeFromUser: PropTypes.string
};
export default React.memo(QuickshipZipCodeEditLocationUI);